import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {NuggetMode} from '../../enums/nugget-mode.enum';
import {DeviceType} from '../../../afb-api/enums/device-type.enum';

@Component({
  selector: 'awair-device-nugget',
  templateUrl: './device-nugget.component.html',
  styleUrls: ['./device-nugget.component.scss']
})

export class DeviceNuggetComponent implements OnInit {

  @HostBinding('class.--selected') hostSelected: boolean = false;

  @Input() nuggetMode: NuggetMode = NuggetMode.Default;
  @Input() deviceName: string = '';
  @Input() deviceType: DeviceType;
  @Input() email: string = '';
  @Input() hasNotification: boolean = false;
  @Input() indexDotColor: string = '#CDD3D8';

  // Names are optional and therefore, need to check for null since .length function is used in the template
  get ownerFirstName(): string {
    if (this._ownerFirstName != null) {
      return this._ownerFirstName;
    }
  }
  @Input()
  set ownerFirstName(value: string) {
    if (value != null) {
      this._ownerFirstName = value;
    }
  }
  private _ownerFirstName: string = '';

  get ownerLastName(): string {
    if (this._ownerLastName != null) {
      return this._ownerLastName;
    }
  }
  @Input()
  set ownerLastName(value: string) {
    if (value != null) {
      this._ownerLastName = value;
    }
  }
  private _ownerLastName: string = '';

  @Input()
  set isSelected(value: boolean) {
    if (value != null) {
      this.hostSelected = value;
    }
  }

  NuggetMode = NuggetMode;

  constructor() {
  }

  ngOnInit() {
  }
}
